import { createActions } from 'redux-actions';

const actions = createActions({
  TASK: {
    SET_TASK_DETAILS: (taskDetails) => ({ taskDetails }),
    API: {
      SET_TASK_DETAILS: undefined
    }
  }
})

const configuration = {
  name: 'setTaskDetails',
  action: actions,
  sagas: undefined,
  reducers: {
    reducer: (state, action) => ({
      ...state,
      createTask: {
        ...state.createTask,
        taskDetails: action.payload.taskDetails
      },
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/task/configurations/setTaskDetails.js